import { StepperStatus, AdditionalPayStepsType } from "./types";
import { OrderPayment } from "types/generated/operations";

const calcStepStatus = (
  step: number,
  currentStep: number,
  status?: StepperStatus
) => {
  if (status && step !== currentStep) return status;

  if (step < currentStep) {
    return "complete";
  } else if (step === currentStep) {
    return "current";
  } else {
    return "pending";
  }
};

export const AdditionalPayStepStructure: AdditionalPayStepsType[] = [
  {
    key: "set-up",
    title: "Set Up",
    status: calcStepStatus,
  },
  {
    key: "payment-details",
    title: "Payment details",
    status: calcStepStatus,
  },
  {
    key: "review",
    title: "Review",
    status: calcStepStatus,
  },
];

export const CLOCKWORK_WEB_PATH = {
  PAYMENTCENTER: "/masspay",
};

export const ADDITIONAL_PAY_FORM_ROUTES = {
  EMPLOYEE_PAY: "employee-pay",
  REIMBURSEMENT: "expense-reimbursement",
  TAXABLEBENEFITSANDALLOWANCES: "benefits-and-allowances",
};

export const SUBPATHS = {
  SET_UP: "set-up",
  PAYMENT_DETAILS: "payment-details",
  REVIEW: "review",
  EDIT: "edit-payment",
};

export const ESTIMATION_BASE_CURRENCY = "USD";

export enum EmployeePayType {
  BONUS = "Bonus",
  COMISSION = "Commission",
  OFF_CYCLE = "Offcycle",
  RETROACTIVE = "Retroactive",
}

export enum ReimbursementPayType {
  REIMBURSEMENT = "Reimbursement",
}

export enum BenefitsAndAllowancesType {
  BENEFITSANDALLOWANCES = "BenefitsAndAllowances",
}

export const RECURRING_CADENCE = {
  PER_PAY_PERIOD: "per_pay_period",
  LAST_PAY_PERIOD_OF_MONTH: "last_pay_period_of_month",
} as const;

export type RecurringCadence = keyof typeof RECURRING_CADENCE;

export const DisbursementOrderTypeMapping = {
  [OrderPayment.Bonus]: EmployeePayType.BONUS,
  [OrderPayment.Commission]: EmployeePayType.COMISSION,
  [OrderPayment.Offcycle]: EmployeePayType.OFF_CYCLE,
  [OrderPayment.Retroactive]: EmployeePayType.RETROACTIVE,
  [OrderPayment.Reimbursement]: ReimbursementPayType.REIMBURSEMENT,
  [OrderPayment.Benefitsandallowances]:
    BenefitsAndAllowancesType.BENEFITSANDALLOWANCES,
} as const;

export type FormPayType =
  | EmployeePayType
  | ReimbursementPayType
  | BenefitsAndAllowancesType;

export type FormPayTypeValue = `${FormPayType}`;
